import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { forwardRefAndName } from "../../../../lib/forwardRefAndName";
import { BaseIcon } from "../../BaseIcon";
export var XCircleIcon24Regular = forwardRefAndName('XCircleIcon24Regular', function (props, ref) {
  return /*#__PURE__*/(
    React.createElement(BaseIcon, _extends({
      ref: ref,
      viewBoxSize: 24
    }, props), /*#__PURE__*/
    React.createElement("path", {
      d: "M9.27071 8.21006C8.97782 7.91717 8.50295 7.91717 8.21005 8.21006C7.91716 8.50295 7.91716 8.97783 8.21005 9.27072L10.9393 12L8.21005 14.7293C7.91716 15.0222 7.91716 15.497 8.21005 15.7899C8.50295 16.0828 8.97782 16.0828 9.27071 15.7899L12 13.0607L14.7293 15.7899C15.0222 16.0828 15.497 16.0828 15.7899 15.7899C16.0828 15.497 16.0828 15.0222 15.7899 14.7293L13.0607 12L15.7899 9.27072C16.0828 8.97783 16.0828 8.50295 15.7899 8.21006C15.497 7.91717 15.0222 7.91717 14.7293 8.21006L12 10.9393L9.27071 8.21006Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 2.25C6.61522 2.25 2.25 6.61522 2.25 12C2.25 17.3848 6.61522 21.75 12 21.75C17.3848 21.75 21.75 17.3848 21.75 12C21.75 6.61522 17.3848 2.25 12 2.25ZM3.75 12C3.75 7.44365 7.44365 3.75 12 3.75C16.5563 3.75 20.25 7.44365 20.25 12C20.25 16.5563 16.5563 20.25 12 20.25C7.44365 20.25 3.75 16.5563 3.75 12Z"
    }))
  );
});